<template>
    <div class="sinomedList">
        <van-row>
            <van-col span="12" style="border-right: 1px solid #e3e3e3" @click="showPopupL">分组浏览</van-col>
            <van-col span="12" @click="showPopupR">排序</van-col>
        </van-row>
        <div class="listCon">
            <p>
                共检索到<span>{{ totalNum }}</span
                >篇文章
            </p>
            <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了">
                <div v-for="(item, index) in list" :key="index" class="con van-clearfix">
                    <h4>
                        <router-link v-html="index + 1 + ' . ' + item.ti" :to="{ path: '/sinomedDetails', query: { url: item.url } }" class="homePan">
                        </router-link>
                    </h4>
                    <dl>
                        <dt>作者:</dt>
                        <dd>{{ item.au }}</dd>
                    </dl>
                    <dl>
                        <dt>作者单位:</dt>
                        <dd>{{ item.affs }}</dd>
                    </dl>
                    <dl>
                        <dt>出处:</dt>
                        <dd>{{ item.so }}</dd>
                    </dl>
                    <!-- <dl>
                        <dt>相关链接:</dt>
                        <dd><a :href="item.url" target="_block">标题相关</a></dd>
                    </dl> -->
                </div>
                <div v-show="listShow">
                    暂无数据
                </div>
            </van-list>
        </div>
        <van-popup v-model="showL" position="left" :style="{ width: '50%', height: '100%' }" get-container="#app">
            <van-cell title="分组浏览" />
            <van-collapse v-model="activeName" accordion @change="facet($event)">
                <van-collapse-item v-for="(item, index) in collapseItem" :key="index" :title="item.title" :name="item.name">
                    <p style="text-align:center;padding: 10px 0;" v-show="shoeP">
                        暂无数据
                    </p>
                    <van-loading size="24px" v-show="shoeLo">加载中...</van-loading>
                    <van-cell v-for="(item1, index1) in activList" :key="index1" :class="{ active: index1 == currentLeft && index == LeftType }">
                        <template slot="title">
                            <span
                                class="custom-title"
                                style="width: 100%; display: block;"
                                @click="facetCick(item.name, item1.key, index1, index)"
                                :data-key="item1.key"
                                >{{ item1.label }}<span style="float:right">({{ item1.value }})</span></span
                            >
                        </template>
                    </van-cell>
                </van-collapse-item>
            </van-collapse>
            <van-button type="info" block @click="cancel()">清除筛选</van-button>
        </van-popup>
        <van-popup v-model="showR" position="right" :style="{ width: '50%', height: '100%' }" get-container="#app">
            <van-cell title="排序" />
            <div>
                <van-cell v-for="(item1, index1) in derUrl" :key="index1" :class="{ active: index1 == currentRight }">
                    <template slot="title">
                        <span
                            class="custom-title"
                            style="width: 100%; display: block;"
                            @click="searchClick($event, index1)"
                            :data-name="item1.name"
                            >{{ item1.title }}</span
                        >
                        <!-- <p id="url" style="display:none">{{ item1.url }}</p> -->
                    </template>
                </van-cell>
            </div>
        </van-popup>
    </div>
</template>
<script>
import qs from "qs";
import api from "../../request/api";
export default {
    data() {
        return {
            list: [],
            totalNum: "",
            loading: false,
            finished: false,
            timer: "",
            showL: false,
            showR: false,
            shoeP: false,
            shoeLo: false,
            isActive: false,
            listShow: false,
            data: {},
            activList: [],
            activeName: 0,
            collapseItem: [
                { title: "时间", name: "DP_YEAR" },
                { title: "期刊", name: "TA" },
                { title: "学科", name: "CN_1" },
                { title: "主题", name: "TMH_2" },
                { title: "作者", name: "AU" }
            ],
            Url: "",
            derUrl: [
                { title: "入库", name: "LIFO" },
                { title: "年代", name: "-dp" },
                { title: "作者", name: "au" },
                { title: "期刊", name: "ta" },
                { title: "相关度", name: "RELEVANCE" },
                { title: "被引频次", name: "-cites" }
            ],
            pageUrl: "",
            page: 1,
            currentLeft: "-1",
            LeftType: "",
            currentRight: "-1",
            event: "",
            facetTerm: []
        };
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: true, title: "中国生物医学文献服务系统", iconType: true });

        this.search();
        let that = this;
        window.onscroll = function() {
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (Math.ceil(scrollTop + windowHeight) == scrollHeight || Math.floor(scrollTop + windowHeight) == scrollHeight) {
                //写后台加载数据的函数
                that.onLoad();
            }
        };
    },
    beforeRouteLeave(to, from, next) {
        // 进入C时B正常缓存 当进入的不是C时 this.$destroy()销毁后
        if (to.name === "sinomedDetails") {
            if (!from.meta.isKeepAlive) {
                from.meta.isKeepAlive = true; // 当我们进入到C时开启B的缓存
            }
            next();
        } else {
            from.meta.isKeepAlive = false;
            this.$vnode.parent.componentInstance.cache = {};
            this.$vnode.parent.componentInstance.keys = [];
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    },
    methods: {
        search() {
            //默认列表数据接口调用
            this.data = this.$route.query;
            delete this.data.facetTerm;
            api.sinomedSearch(this.data).then((response) => {
                // this.$get("sinomed/search", this.data).then(response => {
                if (response.code == 0) {
                    this.totalNum = response.data.total;
                    if (response.data.list == null) {
                        this.listShow = true;
                    } else {
                        this.listShow = false;
                        this.list = response.data.list;
                    }
                    this.pageUrl = response.data.pageUrl;
                }
            });
        },
        //分面面板切换
        facet(event) {
            this.activList = "";
            if (event != "") {
                this.event = event;
                this.shoeLo = true;
                this.shoeP = false;
                api.sinomedFacet({ category: event }).then((response) => {
                    // this.$get("sinomed/facet", { category: event }).then(response => {
                    if (response.code == 0) {
                        this.shoeLo = false;
                        if (response.data.list.length == 0) {
                            this.shoeP = true;
                        } else {
                            this.activList = response.data.list;
                            this.shoeP = false;
                        }
                    }
                });
            }
        },
        //点击分面
        facetCick(name, key, index1, index) {
            this.page = 1;
            this.currentLeft = index1;
            this.LeftType = index;
            var datase = "";
            switch (name) {
                case "DP_YEAR":
                    datase = "时间";
                    break;
                case "TA":
                    datase = "刊名";
                    break;
                case "CN_1":
                    datase = "学科";
                    break;
                case "TMH_2":
                    datase = "主题";
                    break;
                case "AU":
                    datase = "作者";
                    break;
            }
            //   var eTarget = e.target.dataset.key;
            var facetData = '"' + key + '"[' + datase + "]";
            this.facetTerm.push(facetData);
            this.data.facetTerm = this.facetTerm;
            //   console.log(qs.stringify(this.data))
            //   api.sinomedSearch(this.data).then(response => {
            this.$get("sinomed/search?" + qs.stringify(this.data), "").then((response) => {
                if (response.code == 0) {
                    if (response.data.list == null) {
                        this.listShow = true;
                    } else {
                        this.listShow = false;
                        this.list = response.data.list;
                        this.totalNum = response.data.total;
                    }
                    this.showL = false;
                    this.activList = [];
                    this.activeName = -1;
                }
            });
        },
        searchClick(e, index) {
            this.page = 1;
            if (e != "") {
                this.data.sortBy = e.target.dataset.name;
                this.currentRight = index;
            }
            // api.sinomedSearch(this.data).then((response) => {
            this.$get("sinomed/search?" + qs.stringify(this.data), "").then((response) => {
                //   this.$get("sinomed/search", this.data).then(response => {
                if (response.code == 0) {
                    if (response.data.list == null) {
                        this.listShow = true;
                    } else {
                        this.list = response.data.list;
                        this.totalNum = response.data.total;
                        this.pageUrl = response.data.pageUrl;
                        this.showR = false;
                    }
                }
            });
        },
        //加载更多数据
        onLoad() {
            if (this.$route.name === "sinomedList") {
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                this.listShow = false;
                if (this.totalNum == this.list.length) {
                    this.finished = true;
                } else {
                    setTimeout(() => {
                        this.page = Number(this.page) + 1;
                        this.$get("sinomed/next-page", {
                            page: this.page,
                            withCredentials: true
                        }).then((response) => {
                            if (response.code == 0) {
                                this.list = this.list.concat(response.data.list);
                                if (response.data.list == null) {
                                    this.listShow = true;
                                }
                            }
                        });
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.list.length >= this.list.length + 20) {
                            this.finished = true;
                        }
                    }, 1000);
                }
            }
        },
        showPopupL() {
            this.showL = true;
        },
        showPopupR() {
            this.showR = true;
        },
        cancel() {
            this.page = 1;
            this.data = {};
            this.facetTerm = [];
            this.currentLeft = "-1";
            this.search();
            this.showL = false;
        }
    }
};
</script>
<style lang="less">
.van-cell.active {
    span {
        color: red;
    }
}
.van-collapse-item__content {
    padding: 0 16px !important;
    background: #f7f7f7;
    .van-cell {
        background: #f7f7f7;
    }
}
.van-popup {
    > .van-cell {
        font-size: 0.8rem;
        padding-top: 0.8rem;
        padding-bottom: 0.8rem;
        border-bottom: 1px solid #e4e4e4;
    }
    .van-collapse {
        height: 34rem;
        overflow: auto;
    }
    .van-button {
        background: #305359;
        border: 0.05333rem solid #305359;
        position: fixed;
        bottom: 0;
    }
}
.sinomedList {
    margin-top: 0.8rem;
    // background: #fff;
    .van-row {
        border-bottom: 1px solid #e3e3e3;
        height: 2.5rem;
        // padding: 10px 0;
        padding: 0.7rem 0;
        background: #fff;
        .van-col--12 {
            color: #23b8a4;
            text-align: center;
        }
    }
    > p {
        font-size: 0.7rem;
        padding: 0.8rem 1rem;
        color: #b0b0b0;
        background: #fff;
    }
    .listCon {
        background: #fff;
        > p {
            padding: 1rem 1rem 0 1rem;
            color: #9a9a9a;
        }
        .van-list {
            .con {
                border-bottom: 1px solid #e3e3e3;
                padding: 1rem;
                width: 100%;
                height: 100%;
                min-height: 200px;
                h4 {
                    margin-bottom: 15px;
                    a {
                        color: #325156;
                    }
                    font-weight: 400;
                }
                dl {
                    margin-bottom: 0.4rem;
                    color: #9a9a9a;
                    a {
                        color: #9a9a9a;
                    }
                    dt {
                        color: #000;
                        width: 25%;
                        display: inline-block;
                        vertical-align: top;
                    }
                    dd {
                        display: inline-block;
                        width: 75%;
                    }
                }
            }
        }
    }
}
</style>
